import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromSystemConfiguration from './system-configuration.reducer';

export const selectSystemConfigurationState = createFeatureSelector<fromSystemConfiguration.State>(
  fromSystemConfiguration.systemConfigurationFeatureKey
);

export const selectSystemConfig = createSelector(
  selectSystemConfigurationState,
  systemConfigurationState => systemConfigurationState.systemConfig
);

export const selectSystemConfigUpdateInProgress = createSelector(
  selectSystemConfigurationState,
  systemConfigurationState => systemConfigurationState.updateSystemInProgress
);

export const selectSystemConfigLoading = createSelector(
  selectSystemConfigurationState,
  systemConfigurationState => systemConfigurationState.systemConfigLoading
);

export const selectChatHooksChannels = createSelector(
  selectSystemConfigurationState,
  systemConfigurationState => systemConfigurationState.chatHooksChannels
);

export const selectTimerReportLoading = createSelector(
  selectSystemConfigurationState,
  systemConfigurationState => systemConfigurationState.timerReportLoading
);

export const selectTimerReport = createSelector(
  selectSystemConfigurationState,
  systemConfigurationState => systemConfigurationState.timerReport
);

export const selectExpandedSections = createSelector(
  selectSystemConfigurationState,
  systemConfigurationState => systemConfigurationState.expandedSections
);
